<div style="font-family: 'Noto Sans Devanagari', Arial, sans-serif; padding: 10px;">

  <!-- ===== LOADING ===== -->
  <div *ngIf="isLoading" style="text-align:center; padding:30px;">
    <span class="loader"></span>
    <p>Loading...</p>
  </div>

  <!-- ===== DATA TABLE ===== -->
  <ng-container *ngIf="!isLoading && districtwiseData.length > 0">
    <div id="print-section" style="width:100%;">

      <table style="border-collapse:collapse; width:100%; font-size:12px; table-layout:auto;">

        <!-- ════════════════════════════════════════════════════════════
             THEAD — repeats on every printed page automatically
             ════════════════════════════════════════════════════════════ -->
        <thead>

          <!-- ── ROW 1 : Organisation Title ── -->
          <tr>
            <th [attr.colspan]="totalth" style="border:2px solid #000; text-align:center; font-size:15px;
                       font-weight:bold; padding:7px 4px;
                       background:#d0d0d0; color:#000; letter-spacing:.5px;">
              हिंदुस्थान प्रकाशन संस्था &nbsp;–&nbsp; विवेक साप्ताहिक &nbsp;–&nbsp; वर्गणी विभाग
            </th>
          </tr>

          <!-- ── ROW 2 : Report Sub-title ── -->
          <tr>
            <th [attr.colspan]="totalth" style="border:2px solid #000; text-align:center; font-size:13px;
                       font-weight:bold; padding:5px 4px;
                       background:#ebebeb; color:#000;">
              वर्गणी प्रकारानुसार जिल्हानिहाय अहवाल
            </th>
          </tr>

          <!-- ── ROW 3 : Dates — full-width flex row ── -->
          <tr>
            <th [attr.colspan]="totalth" style="border:2px solid #000; padding:0; background:#fff;">
              <div style="display:flex; width:100%; align-items:stretch;">
                <span style="flex:1; padding:4px 8px; border-right:1px solid #999;
                             text-align:left; color:#000; white-space:nowrap; font-weight:normal;">
                  <b>दिनांक पासून :</b>&nbsp;{{ startDate | date:'dd/MM/yyyy' }}
                </span>
                <span style="flex:1; padding:4px 8px; border-right:1px solid #999;
                             text-align:left; color:#000; white-space:nowrap; font-weight:normal;">
                  <b>दिनांक पर्यंत :</b>&nbsp;{{ endDate | date:'dd/MM/yyyy' }}
                </span>
                <span style="flex:1; padding:4px 8px; border-right:1px solid #999;
                             text-align:left; color:#000; white-space:nowrap; font-weight:normal;">
                  <b></b>
                </span>
                <span style="flex:1; padding:4px 8px; text-align:right;
                             color:#000; white-space:nowrap; font-weight:normal;">
                  <b>दिनांक :</b>&nbsp;{{ today | date:'dd/MM/yyyy' }}
                </span>
              </div>
            </th>
          </tr>

          <!-- ── ROW 4 : Filters Line 1 — full-width flex row ── -->
          <tr>
            <th [attr.colspan]="totalth" style="border:2px solid #000; padding:0; background:#fff;">
              <div style="display:flex; width:100%; align-items:stretch;">
                <span style="flex:1; padding:4px 8px; border-right:1px solid #999;
                             text-align:left; color:#000; white-space:nowrap; font-weight:normal;">
                  <b>देश -</b>&nbsp;{{ selectedCountry || 'भारत' }}
                </span>
                <span style="flex:1; padding:4px 8px; border-right:1px solid #999;
                             text-align:left; color:#000; white-space:nowrap; font-weight:normal;">
                  <b>राज्य -</b>&nbsp;{{ selectedState || 'सर्व' }}
                </span>
                <span style="flex:1; padding:4px 8px; border-right:1px solid #999;
                             text-align:left; color:#000; white-space:nowrap; font-weight:normal;">
                  <b>जिल्हा -</b>&nbsp;{{ selectedDistrict || 'सर्व' }}
                </span>
                <span style="flex:1; padding:4px 8px; text-align:left;
                             color:#000; white-space:nowrap; font-weight:normal;">
                  <b>वर्गणी प्रकार -</b>&nbsp;{{ selectedSubType || 'सर्व' }}
                </span>
              </div>
            </th>
          </tr>

          <!-- ── ROW 5 : Filters Line 2 — full-width flex row ── -->
          <tr>
            <th [attr.colspan]="totalth" style="border:2px solid #000; padding:0; background:#fff;">
              <div style="display:flex; width:100%; align-items:stretch;">
                <span style="flex:1; padding:4px 8px; border-right:1px solid #999;
                             text-align:left; color:#000; white-space:nowrap; font-weight:normal;">
                  <b>प्रांत -</b>&nbsp;{{ selectedPrant || 'सर्व' }}
                </span>
                <span style="flex:1; padding:4px 8px; border-right:1px solid #999;
                             text-align:left; color:#000; white-space:nowrap; font-weight:normal;">
                  <b>प्रतिनिधीनिहाय -</b>&nbsp;{{ selectedRepName || 'सर्व' }}
                </span>
                <span style="flex:1; padding:4px 8px; border-right:1px solid #999;
                             text-align:left; color:#000; white-space:nowrap; font-weight:normal;">
                  <b>ऑफीस प्रतिनिधी -</b>&nbsp;{{ selectedOfficer || 'सर्व' }}
                </span>
                <span style="flex:1; padding:4px 8px; text-align:left;
                             color:#000; white-space:nowrap; font-weight:normal;">
                  <b>माध्यमानुसार -</b>&nbsp;{{ selectedDeliveryMode || 'सर्व' }}
                </span>
              </div>
            </th>
          </tr>

          <!-- ── ROW 6 : Sub-type group headers (rowspan=2 for serial & district) ── -->
          <tr>
            <th rowspan="2" style="border:2px solid #000; color:#000; text-align:center; vertical-align:middle;
                       background:#b8b8b8; font-weight:bold; padding:4px 3px; min-width:34px;">
              अनु<br>क्र.
            </th>
            <th rowspan="2" style="border:2px solid #000; color:#000; text-align:center; vertical-align:middle;
                       background:#b8b8b8; font-weight:bold; padding:4px 5px; min-width:90px;">
              जिल्हा
            </th>

            <ng-container *ngFor="let item of subTypesName">
              <th *ngIf="item['isVisible']" colspan="5" style="border:2px solid #000; color:#000; text-align:center;
                         background:#b8b8b8; font-weight:bold; padding:4px;">
                {{ item['name'] }}
              </th>
            </ng-container>

            <th colspan="5" style="border:2px solid #000; color:#000; text-align:center;
                       background:#888; font-weight:bold; padding:4px; color:#fff;">
              एकूण
            </th>

            <th rowspan="2" style="border:2px solid #000; color:#000; text-align:center; vertical-align:middle;
                       background:#b8b8b8; font-weight:bold; padding:4px 5px; min-width:90px;">
              जिल्हा
            </th>
          </tr>

          <!-- ── ROW 7 : पोस्ट / हस्ते / मॅगझीन / डिजिटल / एकूण sub-headers ── -->
          <tr>
            <ng-container *ngFor="let item of subTypesName">
              <ng-container *ngIf="item['isVisible']">
                <th
                  style="border:2px solid #000; color:#000; text-align:center; background:#e0e0e0; padding:3px 2px; min-width:36px;">
                  पोस्ट</th>
                <th
                  style="border:2px solid #000; color:#000; text-align:center; background:#e0e0e0; padding:3px 2px; min-width:36px;">
                  हस्ते</th>
                <th
                  style="border:2px solid #000; color:#000; text-align:center; background:#e0e0e0; padding:3px 2px; min-width:50px;">
                  मॅगझीन</th>
                <th
                  style="border:2px solid #000; color:#000; text-align:center; background:#e0e0e0; padding:3px 2px; min-width:44px;">
                  डिजिटल</th>
                <th
                  style="border:2px solid #000; color:#000; text-align:center; background:#c8c8c8; padding:3px 2px; min-width:36px; font-weight:bold;">
                  एकूण</th>
              </ng-container>
            </ng-container>
            <!-- Grand total sub-cols -->
            <th
              style="border:2px solid #000; text-align:center; background:#aaa; padding:3px 2px; min-width:36px; color:#fff;">
              पोस्ट</th>
            <th
              style="border:2px solid #000; text-align:center; background:#aaa; padding:3px 2px; min-width:36px; color:#fff;">
              हस्ते</th>
            <th
              style="border:2px solid #000; text-align:center; background:#aaa; padding:3px 2px; min-width:50px; color:#fff;">
              मॅगझीन</th>
            <th
              style="border:2px solid #000; text-align:center; background:#aaa; padding:3px 2px; min-width:44px; color:#fff;">
              डिजिटल</th>
            <th
              style="border:2px solid #000; text-align:center; background:#555; padding:3px 2px; min-width:36px; color:#fff; font-weight:bold;">
              एकूण</th>
          </tr>

        </thead>
        <!-- ════════════════════════════════════════════════════════════ -->

        <tbody>
          <!-- ── DATA ROWS ── -->
          <!-- DATA ROWS — only change: add class="print-nowrap" to districtName tds -->
          <tr *ngFor="let item of districtwiseData; let i = index"
            [style.background]="i % 2 === 0 ? '#ffffff' : '#f5f5f5'">
            <td style="border:1px solid #000; color:#000; text-align:center; padding:3px 2px;">{{ i + 1 }}</td>

            <!-- ✅ Added class="print-nowrap" -->
            <td class="print-nowrap" style="border:1px solid #000; color:#000; text-align:left; padding:3px 5px;">{{
              item['districtName'] }}</td>

            <ng-container *ngFor="let data of subTypesName">
              <ng-container *ngIf="data['isVisible']">
                <td style="border:1px solid #000; color:#000; text-align:right; padding:3px 4px;">{{
                  item[getKey(data['name']) + '_पोस्ट'] }}</td>
                <td style="border:1px solid #000; color:#000; text-align:right; padding:3px 4px;">{{
                  item[getKey(data['name']) + '_हस्ते'] }}</td>
                <td style="border:1px solid #000; color:#000; text-align:right; padding:3px 4px;">{{
                  item[getKey(data['name']) + '_मॅगझीन'] }}</td>
                <td style="border:1px solid #000; color:#000; text-align:right; padding:3px 4px;">{{
                  item[getKey(data['name']) + '_डिजिटल'] }}</td>
                <td
                  style="border:1px solid #000; color:#000; text-align:right; padding:3px 4px; font-weight:bold; background:#ececec;">
                  {{ item[getKey(data['name']) + '_एकूण'] }}</td>
              </ng-container>
            </ng-container>

            <td style="border:1px solid #000; color:#000; text-align:right; padding:3px 4px; background:#e0e0e0;">{{
              item['एकूण_पोस्ट'] }}</td>
            <td style="border:1px solid #000; color:#000; text-align:right; padding:3px 4px; background:#e0e0e0;">{{
              item['एकूण_हस्ते'] }}</td>
            <td style="border:1px solid #000; color:#000; text-align:right; padding:3px 4px; background:#e0e0e0;">{{
              item['एकूण_मॅगझीन'] }}</td>
            <td style="border:1px solid #000; color:#000; text-align:right; padding:3px 4px; background:#e0e0e0;">{{
              item['एकूण_डिजिटल'] }}</td>
            <td
              style="border:1px solid #000; color:#000; text-align:right; padding:3px 4px; background:#b8b8b8; font-weight:bold;">
              {{ item['एकूण'] }}</td>

            <!-- ✅ Added class="print-nowrap" -->
            <td class="print-nowrap" style="border:1px solid #000; color:#000; text-align:left; padding:3px 5px;">{{
              item['districtName'] }}</td>
          </tr>

          <!-- ── TOTALS ROW ── -->
          <tr style="background:#c8c8c8;">
            <td colspan="2" style="font-weight:bold; text-align:center; border:2px solid #000;
                       color:#000; padding:5px 4px; font-size:13px;">
              एकूण
            </td>
            <ng-container *ngFor="let data of subTypesName">
              <ng-container *ngIf="data['isVisible']">
                <td style="font-weight:bold; text-align:right; border:2px solid #000; color:#000; padding:3px 4px;">{{
                  districtwiseDataTotal[getKey(data['name']) + '_पोस्ट'] }}</td>
                <td style="font-weight:bold; text-align:right; border:2px solid #000; color:#000; padding:3px 4px;">{{
                  districtwiseDataTotal[getKey(data['name']) + '_हस्ते'] }}</td>
                <td style="font-weight:bold; text-align:right; border:2px solid #000; color:#000; padding:3px 4px;">{{
                  districtwiseDataTotal[getKey(data['name']) + '_मॅगझीन'] }}</td>
                <td style="font-weight:bold; text-align:right; border:2px solid #000; color:#000; padding:3px 4px;">{{
                  districtwiseDataTotal[getKey(data['name']) + '_डिजिटल'] }}</td>
                <td
                  style="font-weight:bold; text-align:right; border:2px solid #000; color:#000; padding:3px 4px; background:#aaa;">
                  {{ districtwiseDataTotal[getKey(data['name']) + '_एकूण'] }}</td>
              </ng-container>
            </ng-container>
            <td style="font-weight:bold; text-align:right; border:2px solid #000; color:#000; padding:3px 4px;">{{
              districtwiseDataTotal['एकूण_पोस्ट'] }}</td>
            <td style="font-weight:bold; text-align:right; border:2px solid #000; color:#000; padding:3px 4px;">{{
              districtwiseDataTotal['एकूण_हस्ते'] }}</td>
            <td style="font-weight:bold; text-align:right; border:2px solid #000; color:#000; padding:3px 4px;">{{
              districtwiseDataTotal['एकूण_मॅगझीन'] }}</td>
            <td style="font-weight:bold; text-align:right; border:2px solid #000; color:#000; padding:3px 4px;">{{
              districtwiseDataTotal['एकूण_डिजिटल'] }}</td>
            <td
              style="font-weight:bold; text-align:right; border:2px solid #000; color:#000; padding:3px 4px; background:#555; color:#fff; font-size:13px;">
              {{ districtwiseDataTotal['एकूण'] }}</td>
            <td style="border:2px solid #000;"></td>
          </tr>
        </tbody>

      </table>
    </div>
  </ng-container>

  <!-- No data -->
  <div *ngIf="!isLoading && districtwiseData.length === 0" style="text-align:center; padding:20px; color:gray;">
    कोणताही डेटा आढळला नाही.
  </div>

  <!-- ===== BUTTONS ===== -->
  <div class="noPrint" style="margin-top:12px; display:flex; gap:10px; flex-wrap:wrap;">
    <button mat-raised-button color="primary" (click)="exportExcel('Districtwise_Report')"
      [disabled]="districtwiseData.length === 0">
      Export
    </button>
    <button mat-raised-button color="primary" (click)="printPage()">
      Print
    </button>
    <button mat-dialog-close class="btn">Close</button>
  </div>

</div>